module.exports = __webpack_public_path__ + "img/France.e1f48254.png";